export interface NavigationCounterProps {
  count: number;
  label: string;
  collapsed?: boolean;
}

export function NavigationCounter({ count, label, collapsed = false }: NavigationCounterProps) {
  if (count <= 0) return null;
  const visual = count > 99 ? '99+' : String(count);
  return (
    <span
      className={`${collapsed ? 'absolute right-1 top-1 h-2.5 w-2.5 p-0' : 'ml-auto min-w-5 px-1.5 py-0.5'} inline-flex items-center justify-center rounded-full bg-brand-500 text-[10px] font-bold leading-none text-white tabular-nums ring-2 ring-slate-950`}
      aria-label={`${label}: ${count}`}
      title={`${label}: ${count}`}
    >
      <span aria-hidden="true">{collapsed ? '' : visual}</span>
    </span>
  );
}
